export default {
  /**
  * Shizen Stats state structuring
  *
  * stats {
  *   data: {
  *     createdActions: {},
  *     finishedActions: {},
  *     actionCreatingTime: {},
  *     createdPb: {},
  *     finishedPb: {},
  *     pbCreatingTime: {},
  *     bugsReported: {},
  *     tasksReported: {},
  *     login: {},
  *     time: {},
  *     finishedMeetings: {},
  *   }
  *   nUsers: 0,
  *   sumNActionsCreated: 0,
  *   sumNActionsFinished: 0,
  *   sumNPbCreated: 0,
  *   sumNPbFinished: 0,
  *   afkTime: 0,
  *   onlineTime: 0,
  *   sumNBugs: 0,
  *   sumNTasks: 0,
  *   companies: [],
  * }
  * statsLoading: false,
  */
  stats: {},
  statsLoading: false,
};
